<div class="hero-cell">
  @if (hero()?.imageUrl; as imageUrl) {
    <div class="hero-flip-card">
      <div class="hero-flip-inner">
        <div class="hero-flip-front">
          <img [src]="imageUrl" [alt]="hero()!.name" class="hero-avatar" />
        </div>
        <div class="hero-flip-back">
          <span class="hero-name">{{ hero()!.name }}</span>
        </div>
      </div>
    </div>
  } @else {
    <span class="hero-placeholder">—</span>
  }
</div>
